import React from 'react';
import PropTypes from 'prop-types';
import FAQMenuStyles from './FAQMenu.styled';
import ChevronDownIcon from '../Shared/Icons/ChevronDown';
import { useInView } from 'react-intersection-observer';
import { NavLink } from 'react-router-dom';

const FAQMenu = ({ children, isAnimated = true }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <FAQMenuStyles
      ref={ref}
      className={`block-faq_menu ${isAnimated && 'isAnimated'} ${
        inView && 'active'
      }`}
    >
      <div className='inner'>
        <div className='menu'>
          <ul>
            <li>
              <NavLink to='/resources/faqs/your-mortgage/'>
                Your Mortgage
              </NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/insurance/'>Insurance</NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/property-taxes-forms/'>
                Property Taxes & Tax Forms
              </NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/payment/'>Payment</NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/your-home/'>Your Home</NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/my-vmf-account/'>
                My VMF Account
              </NavLink>
            </li>
            <li>
              <NavLink to='/resources/faqs/pre-owned-financing/'>
                Pre-owned Financing
              </NavLink>
            </li>
          </ul>
        </div>
        <div className='content'>{children}</div>
      </div>
    </FAQMenuStyles>
  );
};

FAQMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isAnimated: PropTypes.bool,
};

export default FAQMenu;
